import { ResourceSpaceType } from "../../APIService/ResourceSpaceTypeListService";
import "./ResourceSpaceTypeChip.css";

type ResourceSpaceChipProps = {
  theme: string | null;
  resourceSpaceData: ResourceSpaceType;
  selected?: boolean;
  onSelect?: (resource: ResourceSpaceType) => void;
};

const ResourceSpaceChip = ({
  theme,
  resourceSpaceData,
  selected = false,
  onSelect
}: ResourceSpaceChipProps) => {
  return (
  <div
    className={`chip ${theme === "dark" ? "dark" : "light"} ${
      selected ? "selected" : ""
    }`}
    onClick={() => onSelect?.(resourceSpaceData)}
  >
    {resourceSpaceData.icon && (
      <img
        className="chip-icon"
        src={localStorage.getItem("tenantUrl") + resourceSpaceData.icon}
        alt=""
      />
    )}
    <span className="chip-label">{resourceSpaceData.name.startsWith('book'.toLowerCase()) ? resourceSpaceData.name : `Book ${resourceSpaceData.name}`}</span>
  </div>
);
};

export default ResourceSpaceChip;
